import { createContext, useContext } from 'react';
import type {
  tProfilingProgressContext,
  tProfilingState,
} from './ProfilingProgress.types';

/** Neutral state: nothing is syncing or being profiled. Also what the feature
 * flag being off publishes, so gated consumers never see partial progress. */
export const INACTIVE_PROFILING_STATE: tProfilingState = {
  active: false,
  total: 0,
  profiled: 0,
  funnelId: null,
  scene: 'contacts',
  globalProgress: 0,
};

const DEFAULT_PROFILING_PROGRESS_CONTEXT: tProfilingProgressContext = {
  ...INACTIVE_PROFILING_STATE,
  dismiss: () => {},
  recheckSyncStatus: () => {},
};

export const ProfilingProgressContext = createContext<tProfilingProgressContext>(
  DEFAULT_PROFILING_PROGRESS_CONTEXT,
);

export function useProfilingProgressContext(): tProfilingProgressContext {
  return useContext(ProfilingProgressContext);
}
